<template>
<div class="wrapper">
  <div class="about">
     <h1>What it is</h1>
     <img src="../assets/icons/runner.png"/>
      <p>A run/walk/crawl/slither up Bonnington Hill and back down!</p>
      <p>How fast can you do it??</p>

     <hr/>

     <h1>Registration</h1>
     <img src="../assets/icons/form.png"/>

     <ul>
       <li>No day-of registrations. Please register online <a href="#/register">here</a>! It is very easy.</li>
       <li>Registration is <strong>free</strong>, but we will have a <strong>donation box</strong> for the Nelson and Castlegar foodbanks.</li>
       <li>10 spots available! Please register to book a spot. You can book a spot as a <strong>team</strong> or as an <strong>individual</strong>.</li>
       <li>If you register, but <strong>can't make it on the day</strong>, please let us know! We will give the spot to someone else.</li>
     </ul>

     <hr/>

     <h1>Times and Prizes</h1>
     <img src="../assets/icons/timer.png"/>

     <ul>
       <li>We will be doing a <strong>staggered start</strong>! This is to ensure saftey with cars, and to encourage social-distancing.</li>
       <li>Timing is <strong>optional</strong>. We will time you if you want us to!</li>
       <li><strong>Team times</strong> are averages of every team member's time.</li>
       <li>If you are on a team, you will get a <strong>team time</strong> <em>and</em> an <strong>individual time</strong>.</li>
       <li>Special prizes for: <strong>Fastest team</strong> (average), <strong>fastest individual</strong>, and <strong>best costume</strong>.</li>
     </ul>

     <hr/>

     <h1>Run Day</h1>
     <img src="../assets/icons/run.png"/>

     <h2>Date</h2>
     <p>June 28th, 2020</p>
     <h2>Start/End/Prizes Location</h2>
     <p>Bonnington Mailboxes</p>
     <h2>Sign-in</h2>
     <p>8:40am</p>
     <h2>Start time</h2>
     <p>9:00am (staggered start)</p>
     <h2>Prizes</h2>
     <p>10:00am</p>
     <h2>Parking</h2>
     <p>Please don't park at the mailboxes if possible!</p>

     <hr/>

     <h1>FAQs</h1>
     <img src="../assets/icons/faq.png"/>

     <h2>Do I HAVE to run up that dumb hill?</h2>
     <p>No! Run, walk, crawl, roll - any way you want to do it is cool! Except biking. No bikes.</p>
     <h2>Can I bring my pet?</h2>
     <p>Sure can. Bring your dog, cat or snake.</p>
     <h2>Can I bike?</h2>
     <p>No. Snakes don't like bikes.</p>
     <h2>Can I dress up?</h2>
     <p>Please do. Prize for best costume.</p>
     <h2>Will there be prizes?</h2>
     <p>Absolutely! Quality of prizes not guaranteed.</p>
     <h2>Why would anyone do this?</h2>
     <p>Because it's good. Pain is good. It will make you strong.</p>

  </div>
</div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.about {
  background: white;
  padding: 40px;
  margin: 40px auto;
  margin-bottom: 0;
  max-width: 800px;
  color: black;
  box-sizing: border-box;
}

.about p {
  font-size: 20px;
}

.about ul {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  align-items: left;
  list-style: disc;
  padding: 0;
}

.about hr {
  margin: 60px;
}

.about li {
  font-size: 20px;
  text-align: left;
  display: list-item;
  margin-bottom: 10px;
}

.about img {
  width: 80px;
  margin-bottom: 20px;
}
h2 {
  margin-top: 0;
  margin-bottom: 10px;
}

p {
  margin-top: 0;
}

a {
  color: #42b983;
}
</style>
